import React from 'react';
import TcsoChecklistScreen from './TcsoChecklistScreen';
import { TcsoContext, tcsoInitialState, TcsoInputs, TcsoScreenContext, TcsoScreenInputs } from '../../context/TcsoScreenContext';
import TcsoInventoryCheckScreen from './TcsoInventoryCheckScreen';
import TcsoStartScreen from './TcsoStartScreen';

export enum TcsoScreen {
  TCSO_CHECKLIST_SCREEN,
  TCSO_INVENTORY_CHECK_SCREEN,
  TCSO_START_SCREEN,
}

export default function TcsoScreenManager() {
  const [tcsoScreenInputs, setTcsoScreenInputs] = React.useState<TcsoScreenInputs>({
    tcsoScreen: TcsoScreen.TCSO_CHECKLIST_SCREEN,
  });
  const [tcsoInputs, setTcsoInputs] = React.useState<TcsoInputs>(tcsoInitialState);

  function renderScreen() {
    switch (tcsoScreenInputs.tcsoScreen) {
      case TcsoScreen.TCSO_CHECKLIST_SCREEN:
        return <TcsoChecklistScreen />;
      case TcsoScreen.TCSO_INVENTORY_CHECK_SCREEN:
        return <TcsoInventoryCheckScreen />;
      case TcsoScreen.TCSO_START_SCREEN:
        return <TcsoStartScreen />;
      default:
        return <TcsoChecklistScreen />;
    }
  }

  return (
    <TcsoScreenContext.Provider value={{ tcsoScreenInputs, setTcsoScreenInputs }}>
      <TcsoContext.Provider value={{ tcsoInputs, setTcsoInputs }}>{renderScreen()}</TcsoContext.Provider>
    </TcsoScreenContext.Provider>
  );
}
